import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import AccordionItem from "../components/elements/AccordionItem"
import Header from "../components/Header"

function FAQ() {
	const navigate = useNavigate()

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<>
			<Header />
			<div className="container mx-auto max-w-[800px] py-8 px-4   ">
				<h2 className="h2 text-yellow">FAQ – Intuition & Hawaiian Tropic Gewinnspiel</h2>
				<h3 className="h3 text-yellow pb-6">1. Allgemeine Informationen</h3>
				<AccordionItem headline="Wer ist der Veranstalter der Aktion?" num="1">
					<p>
						Veranstalter ist <br />
						<br />
						Wilkinson Sword GmbH
						<br />
						Schützenstraße 110
						<br />
						42659 Solingen
						<br />
						Deutschland
						<br />
						(im Folgenden „Veranstalter“ genannt)
						<br />
						<br />
						Die Aktion wird von der Magellan GmbH, Theo-Champion-Str. 2, D-40549 Düsseldorf, Deutschland und
						der direct services Gütersloh GmbH, Reinhard-Mohn-Str. 300, 33333 Gütersloh, Deutschland
						durchgeführt.
					</p>
				</AccordionItem>
				<AccordionItem headline="Wer kann an der Aktion teilnehmen?" num="2">
					<>
						<p className="pb-6">
							Teilnehmen dürfen natürliche Personen ab 18 Jahren mit Wohnsitz in Deutschland. Mitarbeiter
							des Veranstalters sind nicht teilnahmeberechtigt.
						</p>
						<p>
							Außerdem behält sich der Veranstalter das Recht vor, Personen von der Teilnahme
							auszuschließen, bei denen der Verdacht besteht, dass sie sich bei der Teilnahme unerlaubter
							Hilfsmittel bedienen oder in sonstiger Weise versuchen, sich oder Dritten durch Manipulation
							Vorteile zu verschaffen. Der Ausschluss kann in diesem Fall auch nach der Teilnahme
							erfolgen. Der Veranstalter hat das Recht die Gewinnausschüttung zu verweigern bzw. den
							Gewinn zurückzufordern.
						</p>
					</>
				</AccordionItem>

				<AccordionItem headline="Wie lange kann ich an der Aktion teilnehmen?" num="3">
					<p>
						Der Aktionszeitraum beginnt am 06.05.2026 und endet am 10.06.2026, 23:59 Uhr deutscher Zeit. Ein
						Teilnahmevorgang muss innerhalb dieses Zeitraums vollständig abgeschlossen werden, um als
						gültige Teilnahme akzeptiert zu werden. Über die erfolgreiche Teilnahme wird der Teilnehmer auf
						der Aktionsseite informiert. Voraussetzung für die Teilnahme an der Verlosung ist der Kauf eines
						Aktionsproduktes in der Filiale des teilnehmenden Händlers dm.
					</p>
				</AccordionItem>
				<AccordionItem headline="Welche Produkte sind für die Teilnahme berechtigt?" num="4">
					<p className="pb-6">
						Die Aktion gilt für alle folgenden Produkte, die im Aktionszeitraum in einer Filiale des
						teilnehmenden Händlers dm gekauft werden:
					</p>
					<ul className="pl-6 pb-6">
						<li className="list-disc">4027800176403 Wilkinson Sword Intuition Complete Care Starterpack</li>
						<li className="list-disc">4027800183807 Wilkinson Sword Intuition Eyebrow Shaper XL Pack</li>
						<li className="list-disc">
							4027800179909 Wilkinson Sword Intuition Quattro Sensitive Starterpack
						</li>
						<li className="list-disc">
							4027800190409 Wilkinson Sword Intuition 2in1 Soap&amp;Shave Nourishing Starterpack
						</li>
						<li className="list-disc">
							4027800085002 Wilkinson Sword Intuition und Hawaiian Tropic Summer Essential Giftset
						</li>
					</ul>
					<p className="pb-6">Teilnehmende Händler innerhalb Deutschlands:</p>
					<ul className="pl-6 ">
						<li className="list-disc">dm-drogerie markt GmbH + Co. KG</li>
					</ul>
				</AccordionItem>
				<AccordionItem headline="Wie oft kann eine Person teilnehmen?" num="5">
					<p>
						Pro Teilnehmer sind mehrere Teilnahmen an diesem Gewinnspiel möglich. Pro Teilnahme ist nur ein
						Kaufbeleg anwendbar und stellt somit nur eine Gewinnchance dar, auch wenn mehrere Produkte
						gekauft wurden. Die Teilnahme mittels automatisierter Datenverarbeitungsprozesse und/oder über
						die Einschaltung Dritter (z.B. von Gewinnspielagenturen) ist ausgeschlossen. Eine regelwidrige
						Teilnahme eines Teilnehmers an diesem Gewinnspiel hat seinen Spielausschluss zur Folge.
					</p>
				</AccordionItem>

				<h3 className="h3 text-yellow pb-6">2. Durchführung und Abwicklung</h3>

				<AccordionItem headline="Wie kann ich an der Aktion teilnehmen?" num="6">
					<p className="pb-6">
						Um am Gewinnspiel teilzunehmen, muss der Teilnehmer im Zeitraum vom 06.05.2026 bis 10.06.2026 um
						23:59 Uhr ein Aktionsprodukt in der Filiale des teilnehmenden Händlers dm kaufen und den
						Kaufbeleg auf der Aktionswebsite https://wilkinsonsword.de/pages/frauen/gewinnspiel-Ibiza-2026
						hochladen. Hierbei ist zu beachten, dass der Scan oder das Foto des Original-Rechnungsbelegs
						folgende Punkte deutlich aufzeigt:
					</p>
					<ul className="pl-6 pb-6">
						<li className="list-disc">das teilnehmende Produkt</li>
						<li className="list-disc">das teilnehmende Geschäft</li>
						<li className="list-disc">den Preis</li>
						<li className="list-disc">die Rechnungsbelegnummer</li>
						<li className="list-disc">das Kaufdatum</li>
					</ul>
					<p className="pb-6">
						Der Veranstalter behält sich vor, den Originalkassenbon bis zum Ablauf der Aktion jederzeit für
						etwaige Nachprüfungen einzufordern.
					</p>
					<p>
						Die Ermittlung der Gewinner erfolgt innerhalb von zwei Wochen nach Aktionsende per
						Zufallsziehung aus allen gültigen Teilnahmen. Die Gewinner werden per E-Mail über ihren Gewinn
						und Zustellungstermin informiert und müssen formlos (per E-Mail) die Gewinnannahme bestätigen.
						Nimmt der Teilnehmer den Gewinn nicht an oder meldet sich nach zweimaliger Aufforderung
						innerhalb eines Monats nicht zurück, so verfällt der Gewinnanspruch und ein neuer Gewinner wird
						ermittelt. Der Teilnehmer ist für die Richtigkeit der angegebenen Kontaktdaten verantwortlich.
						Kann der Gewinner aufgrund unvollständiger oder falscher Kontaktdaten nicht kontaktiert werden,
						verfällt der Gewinn, und ein anderer Gewinner wird gemäß den Bestimmungen dieser Klausel
						ausgewählt.
					</p>
				</AccordionItem>
				<AccordionItem headline="Welche Pflichtangaben müssen auf dem Kaufbeleg zu sehen sein?" num="7">
					<p>
						Auf dem Foto müssen alle relevanten Teile des Kassenbelegs gut sichtbar sein. Screenshots von
						digitalen Kaufbelegen sind möglich. Neben den Angaben, die als Teilnahmevoraussetzung
						erforderlich sind, müssen zusätzlich immer der Name des Händlers, der Kaufzeitpunkt (Datum und
						im Idealfall auch die Uhrzeit) und die Gesamtsumme des Kassenbelegs enthalten sein. Es ist nicht
						erlaubt denselben Kassenbeleg für mehrere Teilnahmen zu nutzen. Daten, die für die Teilnahme
						nicht erforderlich sind (z.B. sonstige gekaufte Produkte) können geschwärzt werden. Alle
						Kassenbelege werden automatisiert und nach Bedarf auch manuell überprüft. Bei Zweifel an der
						Echtheit des Belegs sowie bei nicht-lesbaren oder fehlenden Informationen ist eine Teilnahme
						ausgeschlossen.
					</p>
				</AccordionItem>
				<AccordionItem headline="Wie lädt man das Foto vom Kassenbon richtig hoch?" num="8">
					<p>
						Es können beim Upload nur Fotos im Format JPG, PNG und PDF und einer maximalen Größe von 8 MB
						pro Foto hochgeladen werden. Auf dem Kassenbon müssen die folgenden Daten erkennbar sein:
						Kaufdatum, Kaufpreis des Produktes, Bonsumme, Einkaufsstätte sowie das Produkt. Digitale
						Kassenbons (E-Bons) sind ebenfalls zulässig, sofern diese als einzelne Datei (als PDF oder PNG)
						oder Screenshot vorliegen, die alle vorgenannten Informationen aufweist. Auf dem Kassenbon
						abgebildete personenbezogene Daten (z. B. Namen von Beschäftigten) sind nicht abzulichten oder
						vorab zu schwärzen oder in sonstiger Weise unkenntlich zu machen. Unvollständige sowie
						verspätete Angaben können leider nicht berücksichtigt werden.
					</p>
					<p>Der Veranstalter behält sich vor, den Original-Kassenbon nachzufordern.</p>
				</AccordionItem>

				<h3 className="h3 text-yellow pb-6">3. Nach der Teilnahme</h3>

				<AccordionItem headline="Was kann ich gewinnen?" num="9">
					<p className="pb-6">
						Im Aktionszeitraum 06.05.2026 bis 10.06.2026 wird eine Reise nach Ibiza für 2 Personen verlost;
						der Einlöse Zeitraum beträgt 2 Jahre.
					</p>
					<p className="pb-6">
						Der Gewinner stellt mit unserem Reisebüro des Vertrauens seine individuelle Traumreise im Wert
						von bis zu 5.000 € zusammen. Alle Details der Reise werden direkt zwischen Reisebüro und dem
						Gewinner abgestimmt.
					</p>
					<p>
						Eine Barauszahlung der Gewinne ist nicht möglich. Gewinnansprüche können nicht auf andere
						Personen übertragen oder abgetreten werden. Der Rechtsweg ist ausgeschlossen.
					</p>
				</AccordionItem>
				<h3 className="h3 text-yellow pb-6">4. Sonstiges</h3>

				<AccordionItem headline="Kommen ggf. Kosten auf mich zu?" num="11">
					<p>
						Für die Teilnahme sind ein Internetzugang sowie der Kauf eines Aktionsprodukts im teilnehmenden
						Handel erforderlich. Der Gewinner trägt die Kosten für die Einsendung des originalen
						Rechnungsbelegs. Darüber hinaus entstehen keine weiteren Kosten.
					</p>
				</AccordionItem>
				<AccordionItem headline="Welche persönlichen Daten werden für die Teilnahme benötigt?" num="12">
					<p className="pb-6">
						Für die Teilnahme müssen die persönliche E-Mail-Adresse, der vollständige Name sowie die
						Anschrift wahrheitsgemäß und vollständig angegeben werden. Diese Informationen werden benötigt,
						um die Aktion sicher abwickeln zu können.
					</p>
					<p>
						Personenbezogen Daten, die sich möglicherweise auf einem Kaufbeleg befinden und für Teilnahme am
						Gewinnspiel nicht erforderlich sind, sollten geschwärzt werden (z.B. Adressdaten).
					</p>
				</AccordionItem>
				<AccordionItem headline="Wird der Original-Rechnungsbeleg benötigt?" num="13">
					<p>
						Der Veranstalter behält sich vor, den Originalkassenbon bis zum Ablauf der Aktion jederzeit für
						etwaige Nachprüfungen sowie nach Ablauf der Aktion zur Gewinneinlösung einzufordern. Wenn
						gefordert, muss der Teilnehmer den Kassenbon an den Veranstalter bzw. an die Magellan GmbH
						senden.
					</p>
				</AccordionItem>
				<AccordionItem headline="Wie werden Daten im Rahmen der Aktion verarbeitet?" num="14">
					<p className="pb-6">
						Für die Abwicklung der Aktion ist es notwendig, dass personenbezogen Daten verarbeitet werden
						(z.B. E-Mail-Adresse, Name und Anschrift). Diese Daten werden vom Veranstalter und
						Dienstleistern des Veranstalters mit äußerster Sorgfalt und gemäß den gültigen
						Datenschutzbestimmungen verarbeitet. Details sind in der Datenschutzerklärung beschrieben.
					</p>
					<p className="pb-6">
						Alle Teilnahmedaten werden für die gesamte Dauer der Aktion gespeichert und spätestens 6 Wochen
						nach Ende der Aktion gelöscht, sofern keine besondere Einwilligung in eine längerfristige
						Speicherung erfolgte oder eine längerfristige Speicherung aus rechtlichen Gründen erforderlich
						ist. Eine längerfristige Speicherung erfolgt beispielsweise, falls die freiwillige Einwilligung
						für den Empfang eines Newsletters gegeben wurde. Dabei werden nur die tatsächlich benötigten
						Daten gespeichert. Alle nicht benötigten Daten werden auch in diesen Fällen gelöscht.
					</p>
					<p>
						Darüber hinaus können statistische Daten gespeichert werden (z.B. für Nutzungsstatistiken).
						Statistische Daten werden nur in vollständig anonymisierter Form verarbeitet. Ein Rückschluss
						auf einzelne Personen ist dabei ausgeschlossen.
					</p>
				</AccordionItem>
				<AccordionItem headline="Werden Daten von teilnehmenden Personen veröffentlicht?" num="15">
					<p>
						Der Veranstalter wird ohne Erlaubnis grundsätzlich keine Daten von teilnehmenden Personen
						veröffentlichen. Nur nach ausdrücklicher, vorheriger Einwilligung der teilnehmen Personen ist es
						möglich, dass beispielsweise die Gewinnernamen auf einer Website oder in einem Social Media Post
						genannt werden. Auf Wunsch erfolgt die Nennung dabei in anonymisierter Form.{" "}
					</p>
				</AccordionItem>
				<AccordionItem headline="Du hast keine Antwort auf deine Frage erhalten?" num="16">
					<p>
						Das Service-Team ist per E-Mail unter{" "}
						<a href="mailto:Intuition@gewinnspiel-2026.de" className="underline">
							Intuition@gewinnspiel-2026.de
						</a>{" "}
						erreichbar.{" "}
					</p>
				</AccordionItem>
			</div>
			<div className="py-10 pt-5 text-center">
				<button onClick={() => navigate(-1)} className="btn btn-yellow">
					Zurück
				</button>
			</div>
		</>
	)
}
export default FAQ
